export enum AuthorityWorkorder {
  MOVIMENTATION_WORKORDER_CUSTOM_TERMS_VIEW = '12.1.1',
  MOVIMENTATION_WORKORDER_GENERATE_INVOICE_TO_AUTHORIZED = '2.2.19.1',
  MOVIMENTATION_WORKORDER_AUTHORIZED_EDIT_EXIT_KILOMETERS = '2.9',
  MOVIMENTATION_WORKORDER_AUTHORIZED_EDIT_CLOSING_DATE = '2.2.2.1',
  MOVIMENTATION_WORKORDER_AUTHORIZED_EDIT_INDICATE_PHONE = '2.2.2.2',
  MOVIMENTATION_WORKORDER_AUTHORIZED_EDIT_ITEM = '2.2.7.2',
  MOVIMENTATION_WORKORDER_OPENED_EDIT_ITEM = '2.2.7.1',
  MOVIMENTATION_WORKORDER_CHANGE_TYPE = '2.2.49',
  MOVIMENTATION_WORKORDER_INCLUDE_SUPPLIED_PARTS = '2.2.48',
  MOVIMENTATION_WORKORDER_OPENED_ITEM_CHANGE_COST_PRICE = '2.2.35.1',
  MOVIMENTATION_WORKORDER_OPENED_ITEM_CHANGE_DISCOUNT = '2.2.23.1',
  MOVIMENTATION_WORKORDER_OPENED_ITEM_CHANGE_VALUE = '2.2.22.3',
  MOVIMENTATION_WORKORDER_OPENED_ITEM_CHANGE_QUANTITY = '2.2.22.2',
  MOVIMENTATION_WORKORDER_ITEM_CHANGE_QUANTITY = '2.2.22.1',
  MOVIMENTATION_WORKORDER_ITEM_VIEW_INFORMATION = '2.2.47',
  MOVIMENTATION_WORKORDER_ALLOW_EMPTY_ESTIMATED_LEAVE_DATE = '2.2.46',
  MOVIMENTATION_WORKORDER_CLOSED_BLOCK_EDIT_FRANCHISES = '2.2.45',
  MOVIMENTATION_WORKORDER_ITEM_SAVE_WITHOUT_INFORMING_COST = '2.2.44',
  MOVIMENTATION_WORKORDER_ITEM_SAVE_WITHOUT_INFORMING_EMPLOYEE = '2.2.44.1',
  MOVIMENTATION_WORKORDER_ITEM_SAVE_WITHOUT_INFORMING_SUPPLIER = '2.2.43',
  MOVIMENTATION_WORKORDER_ADD_DISCOUNT_PERCENTAGE_GREATER_THAN_DEFINED_BY_THE_COMPANY = '2.2.42',
  MOVIMENTATION_WORKORDER_GIVE_DISCOUNT_OUTSOURCED_SERVICES = '2.2.41',
  MOVIMENTATION_WORKORDER_ADD_EMPLOYEE_TO_COMMISSION = '2.2.40',
  MOVIMENTATION_WORKORDER_ITEM_CHANGE_DESCRIPTION = '2.2.39',
  MOVIMENTATION_WORKORDER_VIEW_COMMISSIONS_PAYMENT = '2.2.38',
  MOVIMENTATION_WORKORDER_CLOSED_ADD_COMMISSION = '2.2.37',
  MOVIMENTATION_WORKORDER_EDIT_OF_OTHER_BUDGETIST = '2.2.36',
  MOVIMENTATION_WORKORDER_ITEM_ADD_SALE_VALUE_BELOW_MINIMUM_MARGIN = '2.2.34',
  MOVIMENTATION_WORKORDER_ITEM_EDIT_COST_PRICE = '2.2.35',
  MOVIMENTATION_WORKORDER_SELECT_ANOTHER_EMPLOYEE = '2.2.33',
  MOVIMENTATION_WORKORDER_ADD_COMMISSION_PART_SUPPLIED = '2.2.32',
  MOVIMENTATION_WORKORDER_ADD_COMMISSION_THIRD_SERVICE = '2.2.31',
  MOVIMENTATION_WORKORDER_ITEM_ADD_BASE_COMMISSION_VALUE_GREATER_THAN_NET_VALUE = '2.2.30',
  MOVIMENTATION_WORKORDER_CHANGE_BASE_COMMISSION_VALUE = '2.2.29',
  MOVIMENTATION_WORKORDER_VIEW_PART_COST_PRICE = '2.2.28',
  MOVIMENTATION_WORKORDER_PRINT_REPORT_OF_COST = '2.2.27',
  MOVIMENTATION_WORKORDER_PRINT_QUOTATION_MAP = '2.2.26',
  MOVIMENTATION_WORKORDER_PRINT_REPORT_FOR_WORKSHOP = '2.2.25',
  MOVIMENTATION_WORKORDER_PRINT_ADMINISTRATIVE_REPORT = '2.2.24',
  MOVIMENTATION_WORKORDER_VIEW_COST_HOUR_ADMINISTRATIVE_BUDGET_REPORTS = '2.2.24.1',
  MOVIMENTATION_WORKORDER_ITEM_EDIT_DISCOUNT_VALUE = '2.2.23',
  MOVIMENTATION_WORKORDER_PART_EDIT_SALE_VALUE = '2.2.22',
  MOVIMENTATION_WORKORDER_SERVICE_EDIT_SALE_VALUE = '2.2.22.4',
  MOVIMENTATION_WORKORDER_CLOSED_REOPEN = '2.2.21',
  MOVIMENTATION_WORKORDER_IMPORT = '2.2.20',
  MOVIMENTATION_WORKORDER_ALLOW_SELLING_BELOW_COST_VALUE = '2.2.18',
  MOVIMENTATION_WORKORDER_VIEW = '2.2.19',
  MOVIMENTATION_WORKORDER_CANCELLED_REOPEN = '2.2.17',
  MOVIMENTATION_WORKORDER_CANCEL = '2.2.16',
  MOVIMENTATION_WORKORDER_CLOSE = '2.2.15',
  MOVIMENTATION_WORKORDER_GENERATE_FINANCIAL = '2.2.14',
  MOVIMENTATION_WORKORDER_AUTHORIZE = '2.2.13',
  MOVIMENTATION_WORKORDER_MAKE_SALE_ABOVE_CREDIT_LIMIT = '2.2.12',
  MOVIMENTATION_WORKORDER_GIVE_DISCOUNT_OVER_LIMIT = '2.2.11',
  MOVIMENTATION_WORKORDER_RESTORE_ITEMS = '2.2.9',
  MOVIMENTATION_WORKORDER_DELETE_ITEM = '2.2.8',
  MOVIMENTATION_WORKORDER_EDIT_ITEM = '2.2.7',
  MOVIMENTATION_WORKORDER_ADD_ITEM = '2.2.6',
  MOVIMENTATION_WORKORDER_ADD_PART_SERVICE_TYPED = '2.2.61',
  MOVIMENTATION_WORKORDER_ADD_COMPLEMENT = '2.2.5',
  MOVIMENTATION_WORKORDER_SEND_QUOTE_BY_EMAIL = '2.2.4',
  MOVIMENTATION_WORKORDER_PRINT = '2.2.3',
  MOVIMENTATION_WORKORDER_EDIT = '2.2.2',
  MOVIMENTATION_WORKORDER_ADD = '2.2.1',
  MOVIMENTATION_WORKORDER_BUDGET = '2.2',
  MOVIMENTATION_WORKORDER_FOLLOW_UP = '2.2.50',
  MOVIMENTATION_WORKORDER_VIEW_FOLLOW_UP_VALUES = '2.2.51',
  MOVIMENTATION_WORKORDER_VIEW_INDICATORS_PAGE = '2.2.52',
  MOVIMENTATION_WORKORDER_KITS_ADD = '1.17.2',
  MOVIMENTATION_WORKORDER_VIEW_HISTORY = '2.2.55',
  MOVIMENTATION_WORKORDER_REGISTER_PART = '2.8.7',
  MOVIMENTATION_WORKORDER_REGISTER_SERVICE = '2.8.8',
}

export const T = {
  ...AuthorityWorkorder,
};
